import { apiSecureRequest, webRequest } from '@utils/request';
import {
	LoginForm,
	LoginSuccessResponse,
	TwoFactorAuthCodeForm,
	TwoFactorAuthenticationSuccessResponse,
	TwoFactorCodeDeliveryMethod,
	TwoFactorMetadata,
	TwoFactorType
} from 'types/authentication';
import { LoginMobileVerifyMeta } from 'types/login';

export const getLoginMobileVerifyMeta = async (): Promise<LoginMobileVerifyMeta> => {
	const response = await apiSecureRequest.get('/login-mobile-verify/visited');
	return response.data;
};

export const getTwoFactorMetadata = async (): Promise<TwoFactorMetadata> => {
	const response = await apiSecureRequest.get('/two-factor-auth/two-factor-meta');
	return response.data;
};

export const persistVisitToLoginMobileVerifyFlow = async (): Promise<void> => {
	return await apiSecureRequest.post('/login-mobile-verify/visited');
};

export const sendEmail2faCode = async (): Promise<void> => {
	await apiSecureRequest.post(`/two-factor-auth/login/email/resend`);
};

export const sendSms2faCode = async (): Promise<void> => {
	await apiSecureRequest.post(`/two-factor-auth/login/mobile/send?textCode=true`);
};

export const sendPhoneCall2faCode = async (): Promise<void> => {
	await apiSecureRequest.post(`/two-factor-auth/login/mobile/send?textCode=false`);
};

export const getTwoFactorStatus = async (): Promise<TwoFactorType> => {
	const response = await apiSecureRequest.get(`/two-factor-auth/status`);
	return response.data.twoFactorStatus;
};

export const submitTwoFactorAuthCode = async (
	twoFactorAuthForm: TwoFactorAuthCodeForm
): Promise<TwoFactorAuthenticationSuccessResponse> => {
	const response = await webRequest.post(`/login/two-factor/verify`, twoFactorAuthForm);
	return response.data;
};

export const resend2faCode = async (method: TwoFactorCodeDeliveryMethod): Promise<void> => {
	switch (method) {
		case 'EMAIL':
			await sendEmail2faCode();
			break;
		case 'SMS':
			await sendSms2faCode();
			break;
		case 'PHONE_CALL':
			await sendPhoneCall2faCode();
			break;
		default:
	}
};

export const submitLoginForm = async (loginForm: LoginForm): Promise<LoginSuccessResponse> => {
	const response = await webRequest.post(`/web-login`, loginForm);
	return {
		redirectUrl: response.data.redirect_url,
		accessToken: response.data.access_token,
		scope: response.data.scope,
		expiresIn: response.data.expires_in
	};
};
